import React from "react";

interface SelectorBoxEntryProps<T> {
    value: T;
    displayField?: string;
    allowDelete?: boolean;
    displayFunc?: (item: T) => string;
    onDelete?: (value: T) => void;
}

class SelectorBoxEntry<T extends {}> extends React.Component<
    SelectorBoxEntryProps<T>
> {
    state = {};

    render(): React.ReactNode {
        return (
            <span
                className={`selector-box-entry${
                    !this.props.allowDelete ? " no-remove-item" : ""
                }`}>
                {this.props.value[this.props.displayField ?? ""] ??
                    this.props.displayFunc?.(this.props.value)}
                {this.props.allowDelete && (
                    <span
                        className="selector-box-entry-remove"
                        onClick={() =>
                            this.props.onDelete?.(this.props.value)
                        }></span>
                )}
            </span>
        );
    }
}

export default SelectorBoxEntry;
